import { useLoaderDataTyped } from "infrastructure/router";
import type { ResourceResponse } from "types";
// import { convertToBooleanSwitch } from "util/transformers";
// import useOnboardingApplication from "features/ecommerce/useOnboardingApplication";
import type { RequestedChangeFileds, WithCompletion, WithOnboardingStep } from "features/ecommerce/types";
import useRequestedChanges from "./useRequestedChanges";

export const useOnboardingStepData = <T extends object>() => {
    // const { isApplicationSubmitted } = useOnboardingApplication();
    const { withRequestedChangeFields } = useRequestedChanges();
    const { data, ...rest } = useLoaderDataTyped<ResourceResponse<WithOnboardingStep<T>>>();

    return {
        ...rest,
        data: {
            ...withRequestedChangeFields<WithOnboardingStep<T>, RequestedChangeFileds>(data),
            // isIncomplete: convertToBooleanSwitch(!isApplicationSubmitted())
        }
    } as ResourceResponse<T & WithCompletion>;
};

export default useOnboardingStepData;
